import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://xtlanjrneydspkiunvtg.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_VXBOPfqSrbqeA_2ITsIkC_QBuJwMd5';

console.log('[supabaseClient] url:', supabaseUrl || 'MISSING');
console.log('[supabaseClient] anonKey:', supabaseAnonKey ? 'present' : 'MISSING');

let supabaseInstance = null;

// A robust recursive proxy builder that returns a no-op / resolved Promise for any chainable call.
function createNoopProxy(path = '') {
    const proxyTarget = Object.assign(async () => {}, {
        then: (resolve) => resolve({ data: null, error: null }),
    });

    return new Proxy(proxyTarget, {
        get(target, prop) {
            if (prop === 'then') {
                return (resolve) => resolve({ data: null, error: null });
            }
            if (prop === 'onAuthStateChange') {
                return () => ({ data: { subscription: { unsubscribe: () => {} } } });
            }
            return createNoopProxy(`${path}.${String(prop)}`);
        },
        apply(target, thisArg, argumentsList) {
            return createNoopProxy(`${path}()`);
        }
    });
}

export const supabase = new Proxy({}, {
    get(target, prop) {
        if (!supabaseUrl || !supabaseAnonKey) {
            if (prop === 'auth') {
                return {
                    getSession: async () => ({ data: { session: null }, error: null }),
                    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
                    signInWithPassword: async () => ({ data: {}, error: new Error('Supabase not configured') }),
                    signUp: async () => ({ data: {}, error: new Error('Supabase not configured') }),
                    signOut: async () => {},
                };
            }
            return createNoopProxy(String(prop));
        }

        if (!supabaseInstance) {
            supabaseInstance = createClient(supabaseUrl, supabaseAnonKey);
        }
        return supabaseInstance[prop];
    }
});
